window.sellsukiVersion = '2b450ac'



//////////////////
// WEBPACK FOOTER
// ./sellsuki_version.js
// module id = 293
// module chunks = 1